import {
	Box,
	Button,
	Checkbox,
	ClickAwayListener,
	Collapse,
	Divider,
	FormControlLabel,
	FormGroup,
	List,
	ListItemButton,
	ListItemText,
	Typography,
} from '@mui/material';
import { Stack } from '@mui/system';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useState } from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useBoundStore } from 'useStore';
import useUsersData from 'views/Components/Shared/Queries/usersQuery';
import useMotivesData from 'views/Components/Forecast/Queries/motivesQuery';
import LightTooltip from 'views/Components/Shared/Components/LightTooltip';

function Options({ closeTooltip, owners, motives }) {
	const [open, setOpen] = useState(null);
	const selectedOwner = useBoundStore((state) => state.fhSelectedOwner);
	const setSelectedOwner = useBoundStore((state) => state.setFhSelectedOwner);
	const resetSelectedOwner = useBoundStore(
		(state) => state.resetFhSelectedOwner
	);
	const selectedMotive = useBoundStore((state) => state.fhMotive);
	const setSelectedMotive = useBoundStore((state) => state.setFhMotive);
	const resetSelectedMotive = useBoundStore((state) => state.resetFhMotive);
	const selectedMargin = useBoundStore((state) => state.fhMargin);
	// const setSelectedMargin = useBoundStore((state) => state.setFhMargin);

	const handleClick = (filter) => {
		setOpen((prev) => (prev === filter ? null : filter));
	};

	const handleClearAndApplyFilters = () => {
		resetSelectedOwner();
		resetSelectedMotive();
		// setSelectedMargin(false);
		closeTooltip();
		setOpen(null);
	};

	return (
		<List
			sx={{ width: '340px', maxWidth: 340, bgcolor: 'background.paper' }}
			component="nav"
			aria-labelledby="nested-list-subheader"
			subheader={
				<Stack
					direction="row"
					spacing={3}
					alignItems="center"
					justifyContent="space-between"
				>
					<Typography
						sx={{
							pl: 2,
							color: 'rgba(0, 0, 0, 0.87)',
							fontFamily: 'Roboto',
							fontStyle: 'normal',
							fontSize: '16px',
							lineHeight: '24px',
							fontWeight: '700',
							letterSpacing: '0.15px',
						}}
					>
						Filtrar por:
					</Typography>
					<Button
						color="secondary"
						onClick={handleClearAndApplyFilters}
						disabled={
							selectedOwner === 0 && selectedMotive === 0 && !selectedMargin
						}
					>
						Limpiar filtros
					</Button>
				</Stack>
			}
		>
			<Divider />

			{owners && (
				<>
					<ListItemButton onClick={() => handleClick('owner')}>
						<ListItemText primary="Category Manager" />
						{open === 'owner' ? <ExpandLess /> : <ExpandMore />}
					</ListItemButton>
					<Collapse in={open === 'owner'} timeout="auto" unmountOnExit>
						<List component="div" disablePadding>
							<Box
								sx={{
									maxHeight: '200px',
									overflowY: 'auto',
								}}
							>
								<FormGroup sx={{ pl: 2 }}>
									{owners.map((owner) => (
										<FormControlLabel
											key={owner.id}
											control={
												<Checkbox
													color="secondary"
													checked={selectedOwner === owner.id}
													onChange={() =>
														selectedOwner === owner.id
															? resetSelectedOwner()
															: setSelectedOwner(owner.id)
													}
												/>
											}
											label={`${owner.name} ${owner.lastname}`}
										/>
									))}
								</FormGroup>
							</Box>
						</List>
					</Collapse>
				</>
			)}

			<Divider />

			{motives && (
				<>
					<ListItemButton onClick={() => handleClick('motive')}>
						<ListItemText primary="Motivo" />
						{open === 'motive' ? <ExpandLess /> : <ExpandMore />}
					</ListItemButton>
					<Collapse in={open === 'motive'} timeout="auto" unmountOnExit>
						<List component="div" disablePadding>
							<Box
								sx={{
									maxHeight: '200px',
									overflowY: 'auto',
								}}
							>
								<FormGroup sx={{ pl: 2 }}>
									{motives.map((motive) => (
										<FormControlLabel
											key={motive.id}
											control={
												<Checkbox
													color="secondary"
													checked={selectedMotive === motive.id}
													onChange={() =>
														selectedMotive === motive.id
															? resetSelectedMotive()
															: setSelectedMotive(motive.id)
													}
												/>
											}
											label={motive?.motivo_str}
										/>
									))}
								</FormGroup>
							</Box>
						</List>
					</Collapse>
				</>
			)}

			<Divider />

			{/* <ListItemButton onClick={() => handleClick('margin')}>
				<ListItemText primary="Margen" />
				{open === 'margin' ? <ExpandLess /> : <ExpandMore />}
			</ListItemButton>
			<Collapse in={open === 'margin'} timeout="auto" unmountOnExit>
				<List component="div" disablePadding>
					<Box
						sx={{
							maxHeight: '200px',
							overflowY: 'auto',
						}}
					>
						<FormGroup sx={{ pl: 2 }}>
							<FormControlLabel
								control={
									<Checkbox
										color="secondary"
										checked={selectedMargin}
										onChange={(event) => {
											setSelectedMargin(event.target.checked);
										}}
									/>
								}
								label="Margen crítico"
							/>
						</FormGroup>
					</Box>
				</List>
			</Collapse>

			<Divider /> */}

			<Button
				color="secondary"
				onClick={closeTooltip}
				sx={{
					mt: 2,
				}}
			>
				Cerrar
			</Button>
		</List>
	);
}

export default function HistoryFiltersOptions() {
	const [open, setOpen] = useState(false);

	const usersQuery = useUsersData();
	const motivesQuery = useMotivesData();

	const handleTooltipClose = () => {
		setOpen(false);
	};

	const handleToggleTooltip = () => {
		setOpen((prev) => !prev);
	};

	return (
		<ClickAwayListener onClickAway={handleTooltipClose}>
			<div>
				<LightTooltip
					PopperProps={{
						disablePortal: true,
					}}
					onClose={handleTooltipClose}
					open={open}
					disableFocusListener
					disableHoverListener
					disableTouchListener
					title={
						<Options
							closeTooltip={handleTooltipClose}
							owners={usersQuery?.data}
							motives={motivesQuery?.data?.filter((m) => m?.estado_id === 1)}
						/>
					}
				>
					<Stack
						direction="row"
						alignItems="center"
						justifyContent="space-between"
						sx={{
							padding: '12px',
							width: '182px',
							borderRadius: '4px',
							border: '1px solid rgba(0, 0, 0, 0.23)',
							cursor: 'pointer',
						}}
						onClick={handleToggleTooltip}
					>
						<Typography
							sx={{
								color: '#00000099',
								fontSize: '16px',
								fontFamily: 'Roboto',
								fontStyle: 'normal',
								fontWeight: '400',
								lineHeight: '24px',
								letterSpacing: '0.15px',
							}}
						>
							Filtrar por
						</Typography>
						<FilterListIcon
							sx={{
								fill: '#0000008F',
								width: '24px',
								height: '24px',
							}}
						/>
					</Stack>
				</LightTooltip>
			</div>
		</ClickAwayListener>
	);
}
